import { CurrencyAmount } from '@kodiak-finance/sdk-core'
import { useMemo } from 'react'
import { Address } from 'viem'

import { useToken } from './Tokens'
import { useIslandUnderlyingBalances } from './useIslandUnderlyingBalances'
import { useApiTokenValue } from './useTokenPrice'

const useIslandTVL = (
  islandId: Address | undefined,
  token0: string | undefined,
  token1: string | undefined,
  cachedUnderlyingBalances?: [any, any]
) => {
  const {
    underlyingAmount0,
    underlyingAmount1,
    loading: underlyingBalancesLoading,
  } = useIslandUnderlyingBalances(cachedUnderlyingBalances ? undefined : islandId)

  const underlying0Balance = cachedUnderlyingBalances?.[0] || underlyingAmount0
  const underlying1Balance = cachedUnderlyingBalances?.[1] || underlyingAmount1

  const _token0 = useToken(token0)
  const _token1 = useToken(token1)

  const underlying0Amount =
    underlying0Balance && _token0 ? CurrencyAmount.fromRawAmount(_token0, underlying0Balance.toString()) : null
  const underlying1Amount =
    underlying1Balance && _token1 ? CurrencyAmount.fromRawAmount(_token1, underlying1Balance.toString()) : null

  const { value: value0 } = useApiTokenValue(underlying0Amount)
  const { value: value1 } = useApiTokenValue(underlying1Amount)

  const tvl = useMemo(() => {
    if (!islandId || !token0 || !token1) {
      return 0
    }

    // If using cached balances, no loading state to check
    if (cachedUnderlyingBalances) {
      return (value0 ?? 0) + (value1 ?? 0)
    }

    // If using hook, check loading state
    if (underlyingBalancesLoading) {
      return 0
    }

    return (value0 ?? 0) + (value1 ?? 0)
  }, [islandId, token0, token1, underlyingBalancesLoading, cachedUnderlyingBalances, value0, value1])
  return tvl
}

export default useIslandTVL
